import React from 'react';
import Maps from './Maps';
import { ShippingAddress, SiDo } from '@remodeling/shop';

export type mapType = 'entire' | 'remodeling';
interface ShopPageProps {
  siDoList?: SiDo[];
  address?: ShippingAddress;
  type: mapType;
  st: string;
}

const ShopSearch = ({ type, address, siDoList, st }: ShopPageProps) => {
  return <Maps type={type} sidoList={siDoList} address={address} st={st} />;
};

export default ShopSearch;
